module.exports = __webpack_public_path__ + "img/stock4.100fc16b.png";